// app/travel-guides/data/provinces.ts

export interface Province {
  id: string;
  name: string;
  image: string;
  description: string;
  districts: string[];
  attractionCount: number;
}

const DIGITAL_OCEAN_SPACES_CDN = "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

export const provinces: Province[] = [
  {
    id: "western",
    name: "Western Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/western.jpg`,
    description: "Home to the commercial capital Colombo, beaches, and vibrant city life",
    districts: ["Colombo", "Gampaha", "Kalutara"],
    attractionCount: 0 // Will be calculated dynamically
  },
  {
    id: "central",
    name: "Central Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/central.jpg`,
    description: "Cultural heart with Kandy, tea plantations, and ancient sites",
    districts: ["Kandy", "Matale", "Nuwara Eliya"],
    attractionCount: 0
  },
  {
    id: "southern",
    name: "Southern Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/southern.jpg`,
    description: "Stunning beaches, Galle Fort, and coastal wildlife",
    districts: ["Galle", "Matara", "Hambantota"],
    attractionCount: 0
  },
  {
    id: "eastern",
    name: "Eastern Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/eastern.jpg`,
    description: "Pristine beaches, Trincomalee harbor, and cultural diversity",
    districts: ["Trincomalee", "Batticaloa", "Ampara"],
    attractionCount: 0
  },
  {
    id: "northern",
    name: "Northern Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/northern.jpg`,
    description: "Rich Tamil heritage, Jaffna culture, and historic sites",
    districts: ["Jaffna", "Kilinochchi", "Mannar", "Vavuniya", "Mullaitivu"],
    attractionCount: 0
  },
  {
    id: "north-central",
    name: "North Central Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/north-central.jpg`,
    description: "Ancient kingdoms of Anuradhapura and Polonnaruwa",
    districts: ["Anuradhapura", "Polonnaruwa"],
    attractionCount: 0
  },
  {
    id: "north-western",
    name: "North Western Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/north-western.jpg`,
    description: "Coconut plantations, lagoons, and historical sites",
    districts: ["Kurunegala", "Puttalam"],
    attractionCount: 0
  },
  {
    id: "sabaragamuwa",
    name: "Sabaragamuwa Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/sabaragamuwa.jpg`,
    description: "Gem mining, Adam's Peak, and lush rainforests",
    districts: ["Ratnapura", "Kegalle"],
    attractionCount: 0
  },
  {
    id: "uva",
    name: "Uva Province",
    image: `${DIGITAL_OCEAN_SPACES_CDN}/Site/images/provinces/uva.jpg`,
    description: "Ella, tea country, and scenic mountain landscapes",
    districts: ["Badulla", "Monaragala"],
    attractionCount: 0
  }
];

// Helper function to get province by ID
export const getProvinceById = (id: string): Province | undefined => {
  return provinces.find(p => p.id === id);
};

// Helper function to normalize province names for matching
export const normalizeProvinceName = (name: string): string => {
  return name.toLowerCase().replace(/\s+/g, '-');
};

// Helper function to get province ID from full name
export const getProvinceIdByName = (name: string): string | undefined => {
  const normalized = normalizeProvinceName(name);
  const province = provinces.find(p => normalizeProvinceName(p.name) === normalized);
  return province?.id;
};